import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";

export class CheckBoxControl extends BaseControl {

    constructor(protected input: HTMLInputElement, controller: Controller, field: string) {
        super(controller, field);

        // save new value on lost focus
        if (controller.automaticUpdateModel) {
            input.addEventListener("click", this.onClickEvent);
        }
    }

    onClickEvent = () => {
        this.saveValue(this.input.checked);
    }

    dispose() {
        this.input.removeEventListener("click", this.onClickEvent);
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        this.input.checked = value ? value : false;
    }

    updateModelFromControl() {
        this.setModelValue(this.input.checked);
    }

    validate() {
    }

    focus() {
        this.input.focus();
    }
}
